module.exports = __webpack_public_path__ + "images/vkb_schnellrechner_scenario_1_web.svg?641cdb69b59f57095a7a1768977f30cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_schnellrechner_scenario_1_web.svg
// module id = 03Uk
// module chunks = 0